import * as React from "react";
import cx from "classnames";

const getInputClass = ({ type = "", meta }): string =>
  cx("form-control__text-area", "form-control__placeholder-input", {
    "has-error": meta.touched && meta.error,
  });

const TextArea = props => (
  <div className={props.className}>
    <textarea
      className={getInputClass(props)}
      disabled={props.disabled}
      placeholder={props.placeholder}
      rows={props.rows}
      {...props.input}
    />
    {props.meta.touched &&
    props.meta.error && (
      <span className="form-control__error">{props.meta.error}</span>
    )}
  </div>
);

export default TextArea;



// WEBPACK FOOTER //
// ./src/components/TextArea.tsx